<template>
  <el-dialog title="" :visible.sync="visible" width="50%" append-to-body>
    <el-card>
      <div class="flex justify-around pt-2">
        <div class="circle cursor-pointer pt-6" @click="jumpArchives">
          <div class="text-xl font-bold text-center">
            {{ globalData["total"] }}
          </div>
          <div class="text-xs text-center font-bold">总调查人数</div>
        </div>
        <div class="circle cursor-pointer pt-6" @click="jumpArchives">
          <div class="text-xl font-bold text-center">
            {{ globalData["peopleWithDiseasesTotal"] }}
          </div>
          <div class="text-xs text-center font-bold">患病人数</div>
        </div>
        <div class="circle cursor-pointer pt-6" @click="jumpArchives">
          <div class="text-xl font-bold text-center">
            <!-- {{ globalData["peopleWithDiseasesRate"] | formatNum }}% -->
            {{ globalData["peopleWithDiseasesRate"] | formatNum }}%
          </div>
          <div class="text-xs text-center font-bold">患病率</div>
        </div>
      </div>
    </el-card>
    <el-card class="mt-2 h-full">
      <IllnessBarChart ref="IllnessBarChartRefs"></IllnessBarChart>
    </el-card>
  </el-dialog>
</template>
<script>
import { mapGetters } from "vuex";
import IllnessBarChart from "./IllnessBarChart.vue";

export default {
  data() {
    return {};
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show(n) {
      if (n) {
        if (n) {
          this.$nextTick(() => {
            console.log(
              "this.IllnessBarChartRefs",
              this.$refs["IllnessBarChartRefs"]
            );
            this.$refs["IllnessBarChartRefs"].initChart();
          });
        }
      }
    },
  },
  components: {
    IllnessBarChart,
  },
  filters: {
    formatNum(num) {
      if (!num) return 0;
      let sum = 0;
      sum = (num * 100).toFixed(1);
      return sum;
    },
  },
  computed: {
    ...mapGetters(["globalData", "mapKey", "communityKey"]),
    visible: {
      get() {
        return this.show;
      },
      set(n) {
        this.$emit("update:show", n);
      },
    },
  },
  methods: {
    async jumpArchives() {
      let accessToken = await this.$store.dispatch("app/getToken");
      if (!accessToken) return;
      window.open(
        `${process.env.VUE_APP_ARCHIVES_DOMAIN}?accessToken=${accessToken}&&street=${this.mapKey}&&community=${this.communityKey}`
      );
    },
  },
  mounted() {},
};
</script>
